import React from 'react';
import PropTypes from 'prop-types';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  FormFeedback
} from 'reactstrap';
import withValidation from '../withValidation';
import styles from './styles.scss';


const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  placeholder: PropTypes.string
};

class PasswordInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
    this.toggleDisplayMode = this.toggleDisplayMode.bind(this);
  }

  toggleDisplayMode() {
    this.setState((prevState) => ({
      visible: !prevState.visible
    }));
  }

  render() {
    const {
      value,
      onChange,
      error,
      invalid,
      placeholder='Password'
    } = this.props;
    const { visible } = this.state;

    return (
      <InputGroup>
        <InputGroupAddon
          onClick={this.toggleDisplayMode}
          addonType='prepend'
        >
          <InputGroupText className={`${styles.iconWrapper}`}>
            <i className={`${styles.icon} fa fa-eye${visible ? '': '-slash'}`} />
          </InputGroupText>
        </InputGroupAddon>
        <Input className={`${styles.password}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          type={visible ? 'input': 'password'}
          invalid={invalid}
        />
        <FormFeedback className='text-left'>
          {error}
        </FormFeedback>
      </InputGroup>
    );
  }
}

PasswordInput.propTypes = propTypes;

export default withValidation(PasswordInput);


// WEBPACK FOOTER //
// src/components/shared/PasswordInput/index.jsx